module.exports = __webpack_public_path__ + "img/userA06.4d5b0474.jpg";